import { ProjectMember } from '@ih/app/shared/apis/interfaces';

export class AcceptProjectMember {
  public static readonly type =
    '[Project/ProjectMember/List] AcceptProjectMember';
  constructor(public readonly projectMember: ProjectMember) {}
}
